export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');
  $(`#${widgetName}`).videoWidget({

    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
    , detectIpad: IPADDETECTED
    // options
    , multiVideo: false
    , showOnMobile: true
    , maxVideos: 1
    , autoPlayVideo: false
    , loopVideo: false
    , trackingGA: {
      present: false,
      event: 'event',
      gaObj: {
        eventCategory: 'Videos',
        eventAction: '',
        eventLabel: '',
        loopVideo: true
      }
    }
    ,
    videoWidgetLoaded: function (data) {
      let videoStartTime = 0;
      let videoControls = 1;

      if (videoStartTime > 0) {
        videoStartTime = `&amp;start=${videoStartTime}`
      } else {
        videoStartTime = "";
      }

      if (videoControls === 0) {
        videoControls = `&amp;controls=${videoControls}`;
      } else {
        videoControls = "";
      }

      let videoSrc = $('#videoWidget iframe').attr('src');
      $('#videoWidget iframe').attr('src', `${videoSrc}${videoStartTime}${videoControls}`)

      if (data.Slides.length < 1) {
        $('.video-wrapp').remove();
      }
    }
  });
};
